export default "__VITE_ASSET__BH7bjU6u__"